import { Component, Input, NgModule, SimpleChange, SimpleChanges } from '@angular/core';
import { Employee, Farm, GetUsersResponseType, Product, Review, SendCustomerInfo } from '../../../models/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePageService } from '../../services/profile-page.service';
import { MarketPageService } from '../../services/market-page.service';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginService } from '../../services/login.service';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar, faSun, faUser } from '@fortawesome/free-solid-svg-icons';
import { StarRatingModule } from 'angular-star-rating';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { EventApi } from '@fullcalendar/core';

@Component({
  selector: 'app-all-events-modal',
  standalone: true,
  imports: [    
    CommonModule,
    FormsModule, 
    ReactiveFormsModule, 
    NgxCaptchaModule, 
    FontAwesomeModule, 
    StarRatingModule],
  templateUrl: './all-events-modal.component.html',
  styleUrl: './all-events-modal.component.scss'
})

export class AllEventsModalComponent {
  @Input() events!: EventApi[];

  visibleEvents: EventApi[] = [];
  showMore: boolean = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['events'] && !changes['events'].firstChange) {
      this.updateVisibleEvents();
    }
  }

  ngOnInit(): void {
    this.updateVisibleEvents();
  }

  updateVisibleEvents(): void {
    if (this.events.length > 10) {
      this.visibleEvents = this.events.slice(0, 1); // Show only the first event
      this.showMore = true;
    } else {
      this.visibleEvents = this.events;
      this.showMore = false;
    }
  }

  handleShowMore(): void {
    this.visibleEvents = this.events;
    this.showMore = false;
  }
}